import PreparationOrderPrintLabelForm from 'components/PreparationOrderPrintLabelForm/PreparationOrderPrintLabelForm';
import PreparationOrderDetailTable from 'components/PreparationOrderDetailTable/PreparationOrderDetailTable';
import './warehouse-order-preparation.scss';

export default function WarehouseOrderPreparation({
  userCanPrint,
  setIsPrinting,
  preparationOrder,
  updatePreparationOrder = () => {},
}) {
  return (
    <div className="warehouse-order-preparation">
      <div className="warehouse-order-preparation__form">
        {userCanPrint && (
          <PreparationOrderPrintLabelForm
            setIsPrinting={setIsPrinting}
            preparationOrder={preparationOrder}
            onLabelConfirmed={updatePreparationOrder}
          />
        )}
      </div>
      <div className="warehouse-order-preparation__remaining-labels">
        <div className="warehouse-order-preparation__remaining-labels-value">
          {preparationOrder?.labels?.length}
        </div>
        <div className="warehouse-order-preparation__remaining-labels-title">
          etiquetas pendientes de imprimir
        </div>
      </div>
      {!!preparationOrder?.table?.length && (
        <PreparationOrderDetailTable
          preparationOrder={preparationOrder}
          onBatchPrintingFinished={updatePreparationOrder}
        />
      )}
    </div>
  );
}
